
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/priority-illegal-content-uk",
      function () {
        return require("private-next-pages/[lang]/legal/priority-illegal-content-uk/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/priority-illegal-content-uk"])
      });
    }
  